<script setup>
import { useLoading } from '@/utils/stores/loading'

const { t } = useI18n()

const loadingStore = useLoading()

const { isLoading } = storeToRefs(loadingStore)

watch(isLoading, (n, o) => {
  if(!n) {
    setTimeout(() => {
      loadingStore.message = t("loading...")
    }, 200)
  }
})
</script>

<template>
  <VDialog
    v-model="loadingStore.isLoading"
    persistent
    width="300"
  >
    <VCard
      color="primary"
      width="300"
    >
      <VCardText class="pt-3">
        {{ loadingStore.message }}
        <VProgressLinear
          indeterminate
          color="white"
          :height="8"
          class="mb-0 mt-4"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>
